<template>
  <div
    class="zoom-image"
    @mousemove="handleMouseMove"
    @mouseleave="handleMouseLeave"
  >
    <template v-if="enableImageSeo">
      <a
        :href="cleanUrl"
        tabindex="-1"
      >
        <fn-picture
          :key="formattedSrc"
          :src="formattedSrc"
          :alt="alt ? alt : ''"
          :width="1"
          :height="1"
          :fetchpriority="fetchpriority"
          :lazy="lazy"
          clean-url
        />
      </a>
    </template>
    <template v-else>
      <fn-picture
        :key="formattedSrc"
        :src="formattedSrc"
        :alt="alt ? alt : ''"
        :width="1"
        :height="1"
        :fetchpriority="fetchpriority"
        :lazy="lazy"
        clean-url
      />
    </template>

    <div
      v-show="visible"
      ref="overlay"
      class="zi-overlay"
      :style="{
        backgroundImage: `url(${zoomSrc})`,
      }"
    />
  </div>
</template>

<script>
import WindowResize from '@/mixins/WindowResize';

export default {
  mixins: [WindowResize],
  props: {
    src: {
      type: String,
      required: true,
    },
    zoomSrc: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    enableImageSeo: {
      type: Boolean,
      default: false,
    },
    fetchpriority: {
      type: [String, Boolean],
      default: '',
    },
    lazy: {
      type: Boolean,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    cleanUrl() {
      if (this.zoomSrc.includes('?')) {
        return this.zoomSrc.split('?')[0];
      }
      return this.zoomSrc;
    },
    formattedSrc() {
      if (this.windowWidth >= 768) {
        return `${this.src}?t=prod_m`;
      }

      return `${this.src}?t=prod_s`;
    },
  },
  methods: {
    handleMouseLeave() {
      this.visible = false;
    },

    handleMouseMove(event) {
      if (!window.matchMedia(MEDIA_MIN_M).matches) {
        return;
      }

      this.visible = true;

      const dimensions = this.getDimensions();
      const cursorPosition = this.getCursorPosition(dimensions, event);
      const backgroundPosition = this.getBackgroundPosition(dimensions, cursorPosition);

      if (this.$refs.overlay) {
        this.$refs.overlay.style.backgroundPosition = `${backgroundPosition.x}% ${backgroundPosition.y}%`;
      }
    },

    getBackgroundPosition(dimensions, cursorPosition) {
      return {
        x: Math.round(100 / (dimensions.width / cursorPosition.x)),
        y: Math.round(100 / (dimensions.height / cursorPosition.y)),
      };
    },

    getDimensions() {
      return this.$el.getBoundingClientRect();
    },

    getCursorPosition(dimensions, event) {
      return {
        x: event.clientX - dimensions.left,
        y: event.clientY - dimensions.top,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.zoom-image {
  position: relative;
  display: inline-block;

  .zi-overlay {
    position: absolute;
    overflow: hidden;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-color: palette(grey);
    background-repeat: no-repeat;
  }

  img {
    display: block;
    width: 100%;
  }
}
</style>
